// Add your custom JS here.
import PhotoSwipeLightbox from 'photoswipe/lightbox';
import PhotoSwipe from 'photoswipe';

function resizeWindow() {
	let htmlHeight = window.innerHeight;
	let htmlWidth = window.innerWidth;

	if (htmlWidth >= 720) {
		let paddings = 32;
		let resultContainerHeight = htmlHeight - paddings;
		const mapContainerEl = document.querySelector("#col-carte");
		const mapEl = document.querySelector("#backyou-map");
		if (mapContainerEl && mapEl) {
			mapContainerEl.style.height = resultContainerHeight + "px";
			mapEl.style.height = resultContainerHeight + "px";
		}
	}
}

if (document.getElementById('archive-hotels-container')) {
	addEventListener("resize", (event) => {
		resizeWindow();
	});
	resizeWindow();



	const btns = document.querySelectorAll('#tab-liste-carte .btn-check');
	btns.forEach(btnEl => {

		let target = btnEl.dataset.target;
		btnEl.addEventListener('click', event => {
			document.querySelectorAll('.col-archive').forEach(colEl => {
				colEl.classList.add('d-none');
			});
			if (document.getElementById(target)) {
				document.getElementById(target).classList.remove('d-none');
			}
		})
	})

}

if (document.getElementById('wrapper-footer')) {

	const options = {
		dataSource: []
	};

	const images = document.querySelectorAll('.image-gallery');
	images.forEach((span) => {
		options.dataSource.push(
			{
				src: span.dataset.imgUrl,
				width: span.dataset.width,
				height: span.dataset.height
			}
		)
	});

	document.querySelectorAll('.hotel-image').forEach((img) => {
		img.onclick = () => {
			options.index = 0; // defines start slide index
			const pswp = new PhotoSwipe(options);
			pswp.init(); // initializing PhotoSwipe core adds it to DOM
		}
	});
}

const container = document.getElementById('archive-hotels-container');
if (container) {

	let observer = new IntersectionObserver(function (entries, observer) {
		for (let entry of entries) {
			if (entry.isIntersecting && entry.target.dataset.imgLoaded == 0) {
				entry.target.dataset.imgLoaded = 1;
				if (entry.target.dataset.imgUrl != '') {
					const link = entry.target.querySelector('a');
					if (link) link.innerHTML = '<img class="index_image" src="' + entry.target.dataset.imgUrl + '" title="' + entry.target.dataset.imgTitle + '">';
				}
			}
		}
	});

	container.querySelectorAll('.image').forEach((img) => {

		if (img.dataset.imgLoaded == 0) {
			observer.observe(img);
		}

	});



}

(function ($) {
	// OneTrust Cookies Settings button
	let span = document.createElement('span');
	span.innerText = " - ";
	let button = document.createElement('button');
	button.id = "ot-sdk-btn";
	button.classList.add('ot-sdk-show-settings', 'btn', 'btn-link', 'p-0');
	button.style.fontSize = "16px";
	button.style.fontWeight = "300";
	button.style.background = "none";
	button.style.border = "none";
	button.style.setProperty('padding-bottom', '2px', 'important');
	button.innerText = "Cookies";
	let footer = document.querySelector('footer > div');
	footer?.appendChild(span);
	footer?.appendChild(button);

	// OneTrust Cookies List
	let div = document.createElement('div');
	div.id = "ot-sdk-cookie-policy";
	div.style.display = "none";
	document.body?.appendChild(div);


	$(".read-more").on("click", function () {
		$($(this)).parent('div').addClass('open');
	});

	$(".read-less").on("click", function () {
		$($(this)).parent('div').removeClass('open');
	});

	$(".read-less").on("click", function () {
		$($(this)).parent('div').removeClass('open');
	});

	if ($('body').hasClass('single-hotel')) {
		// A $( document ).ready() block.
		var $anchors_menu = $('#anchor_menu');
		var $anchors_link = $('#anchor_menu a');
		var anchor_action = false;
		var tab_position = [];

		var update_tab_pos = function () {
			var anchor_action = false;
			let sticky_h = $('#sticky_menu').height();
			$anchors_link.each(function () {
				let anchor = $(this).attr('href');
				let offset = $(anchor).offset();
				if (offset) {
					tab_position[anchor] = Math.round((offset.top - 40) - sticky_h);
				} else {
					$(this).parent().remove();
				}
			});
			tab_position.reverse();
		};
		update_tab_pos();

		$(window).on("resize", function () {
			update_tab_pos();
		});

		$anchors_link.on('click', function (e) {
			let anchor = $(this).attr('href');
			anchor_action = true;
			$(window).scrollTop(anchor !== '#DESCRIPTION' ? tab_position[anchor] : null);
			setTimeout(function () {
				anchor_action = false;
			}, 1000);
		});

		$(window).scroll(function () {
			if (anchor_action) return false;
			let h = $(this).scrollTop();

			$anchors_link.removeClass('active');
			$anchors_link.first().addClass('active');

			for (var i in tab_position) {

				if (h - tab_position[i] >= -40) {
					$anchors_link.removeClass('active');
					$anchors_menu.find('a[href="' + i + '"]').addClass('active');


				}
			}
		});
	}

	if ($('#search-reset').length) {

		if ($('#search-lieu').val().trim() != "" || $('#search-maxpax').val().trim() != "" || $('#search-rooms').val().trim() != "") {
			$('#search-reset').removeClass('d-none');

		}
	}

	const ga_event_object = function (datas = {}) {
		if (datas?.event) {
			let obj = { event: datas.event, event_data: {} };

			const reg_event_name = new RegExp('^event_name');
			if (Object.keys(datas).filter(k => reg_event_name.test(k))) {
				obj.eventName = datas.event_name;
			};

			const reg_event_data = new RegExp('^event_data_');
			for (var i in datas) {
				if (reg_event_data.test(i)) {
					obj.event_data[i.replace(reg_event_data, '')] = datas[i];
				};
			}

			return obj;
		}

		return null;
	};

	const ga_push_dataLayer = function (type, obj) {
		dataLayer.push({
			'event_data': null
		});
		if (type === 'load') {
			dataLayer.push({
				'user_data': null
			});
		}
		dataLayer.push(obj);

		// Debug dataLayer
		if (typeof DEBUG_DATALAYER != 'undefined' && !!DEBUG_DATALAYER) {
			console.info('DEBUG dataLayer:', JSON.stringify(dataLayer));
		}
	};

	// GA Pages
	$('.ga').each(function () {
		let datas = $(this).data();
		let obj = ga_event_object(datas);
		if (null !== obj) {
			if (obj.event_data?.hotel_rid_code) {
				obj.event_data.hotel_rid_code = obj.event_data.hotel_rid_code.toString();
			}
			ga_push_dataLayer(datas.ga, obj);
		}
		$(this).removeClass('ga');
	});

	// GA Events
	$('.ga-link-event').off('click').on('click', function () {
		let datas = $(this).data();
		let obj = ga_event_object(datas);

		switch (obj?.eventName) {
			case 'booking_form_submit': // When user searches successfully
				const adult_nb = $('#search-maxpax').val();
				const destination = $('#search-lieu').val();
				const room_nb = $('#search-rooms').val();
				obj.event_data.adult_nb = (adult_nb != '' ? parseInt(adult_nb) : null);
				obj.event_data.destination = (destination != '' ? destination : null);
				obj.event_data.room_nb = (room_nb != '' ? parseInt(room_nb) : null);
				if (adult_nb != '' || destination != '' || room_nb != '') {
					ga_push_dataLayer('event', obj);
				}
				break;
			case 'bloc_interact':
				const hotel_rid_code = obj?.event_data?.hotel_rid_code;
				if (hotel_rid_code) {
					obj.event_data.hotel_rid_code = hotel_rid_code.toString();
				}
				if (null !== obj) {
					ga_push_dataLayer(datas.ga, obj);
				}
				break;
			default:
				if (null !== obj) {
					ga_push_dataLayer(datas.ga, obj);
				}
				break;
		}
	});


})(jQuery);

var map_single_hotel = document.getElementById('map_single_hotel');
if (map_single_hotel !== null) {
	let lat = parseFloat(map_single_hotel.getAttribute('data-latitude'));
	let lng = parseFloat(map_single_hotel.getAttribute('data-longitude'));
	var map_s_h = new google.maps.Map(map_single_hotel, {
		center: { lat: lat, lng: lng },
		zoom: 14,
		minZoom: 3,
		disableDefaultUI: true,
		zoomControl: true,
		styles: [{
			featureType: 'poi',
			stylers: [{ visibility: 'off' }]
		}]
	});

	const mark_ap_single_hotel = new google.maps.Marker({
		position: { lat: lat, lng: lng },
		map: map_s_h,
		icon: '/wp-content/themes/backyou-understrap/images/marker.png',
	});
}




